/**
 * ChatSettingsPanel — app-wide chat settings, opened from the chat list header.
 * The same controls also live under Settings → Chat.
 */

import { Settings2, X } from "lucide-react";

import { ChatPreferences } from "./chat-preferences";

export function ChatSettingsPanel({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[120] flex items-end justify-center sm:items-center">
      <div className="absolute inset-0 bg-black/55 backdrop-blur-sm" onClick={onClose} />

      <div className="animate-slide-up relative z-10 flex max-h-[90dvh] w-full max-w-md flex-col overflow-hidden rounded-t-3xl border border-white/[0.07] bg-[#0e1114] pb-[env(safe-area-inset-bottom)] sm:pb-0 text-[#e7e9ea] shadow-[0_30px_80px_-20px_rgba(0,0,0,0.9)] sm:rounded-3xl">
        <header className="flex shrink-0 items-center justify-between border-b border-white/[0.06] px-5 py-3.5">
          <div className="flex items-center gap-2">
            <Settings2 className="h-4 w-4 text-[#ff6b8f]" />
            <h3 className="text-sm font-black tracking-wide">Chat settings</h3>
          </div>
          <button
            onClick={onClose}
            aria-label="Close"
            className="flex h-8 w-8 items-center justify-center rounded-full text-[#71767b] transition hover:bg-white/[0.06] hover:text-[#e7e9ea]"
          >
            <X className="h-4 w-4" />
          </button>
        </header>

        <div className="min-h-0 flex-1 overflow-y-auto px-5 py-5">
          <ChatPreferences compact />
        </div>
      </div>
    </div>
  );
}
